import type { CurriculumApi } from '~/@entities/Curriculum/api'

// schema에서 활용하는 값

/***************** 학교 *****************/
/**
 * 학년 타입 (초, 중, 고)
 * ELEMENTARY: 초등학교
 * MIDDLE: 중학교
 * HIGH: 고등학교
 */
export const SCHOOL_TYPE = {
  초등학교: 'ELEMENTARY',
  중학교: 'MIDDLE',
  고등학교: 'HIGH',
} as const satisfies Record<'초등학교' | '중학교' | '고등학교', CurriculumApi.SchoolType>
/**
 * 학교 종류 한글(Full)
 */
export const SCHOOL_TYPE_KO_FULL = {
  ELEMENTARY: '초등학교',
  MIDDLE: '중학교',
  HIGH: '고등학교',
} as const satisfies Record<CurriculumApi.SchoolType, '초등학교' | '중학교' | '고등학교'>

/**
 * 학교 종류 한글(Short)
 */
export const SCHOOL_TYPE_KO_ABBR = {
  ELEMENTARY: '초',
  MIDDLE: '중',
  HIGH: '고',
} as const satisfies Record<CurriculumApi.SchoolType, '초' | '중' | '고'>
